/**
 * GalleryCard.tsx - GalleryCard - Individual card in gallery view
 * 
 * CHANGE HISTORY:
 * - 251021_0438 [46df53c] danielbeer: feat: complete comprehensive package migration to full standards
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';

const GalleryCard = ({
  item,
  getField,
  dimensions,
  layout,
  showTags,
  showDates,
  showDescriptions,
  onClick,
  onDelete,
  onDragStart,
  onDrop,
  onDragOver
}) => {
  const name = getField(item, 'name') || 'Untitled';
  const description = getField(item, 'description') || '';
  const coverImage = getField(item, 'coverImage') || getField(item, 'url');
  const tags = getField(item, 'tags') || [];
  const color = getField(item, 'color') || 'var(--border-light)';
  const createdAt = getField(item, 'createdAt');
  const icon = getField(item, 'icon');
  
  const formattedDate = createdAt 
    ? new Date(createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : '';
  
  return (
    <div
      className={`gallery-card layout-${layout}`}
      style={{ minHeight: dimensions.minHeight }}
      onClick={onClick}
      draggable
      onDragStart={onDragStart}
      onDrop={onDrop}
      onDragOver={onDragOver}
    >
      {/* Cover image or color */}
      {coverImage ? (
        <div className="gallery-card-cover" style={{ backgroundImage: `url(${coverImage})` }} />
      ) : (
        <div className="gallery-card-cover-color" style={{ backgroundColor: color }}>
          {icon && <span className="gallery-card-icon">{icon}</span>}
        </div>
      )}
      
      {/* Content */}
      <div className="gallery-card-content">
        <h3 className="gallery-card-title">{name}</h3>
        
        {showDescriptions && description && (
          <p className="gallery-card-description">
            {description.substring(0, 150)}
            {description.length > 150 ? '...' : ''}
          </p>
        )}
        
        {showTags && tags.length > 0 && (
          <div className="gallery-card-tags">
            {tags.slice(0, 3).map((tag, index) => (
              <span key={index} className="gallery-card-tag">
                {tag}
              </span>
            ))}
            {tags.length > 3 && (
              <span className="gallery-card-tag-more">+{tags.length - 3}</span>
            )}
          </div>
        )}
        
        {showDates && formattedDate && (
          <div className="gallery-card-date">{formattedDate}</div>
        )}
      </div>
      
      {/* Actions */}
      <div className="gallery-card-actions">
        <button
          className="gallery-card-delete"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          title="Delete"
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

export default GalleryCard;
